<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https" /> {{ caption }}
        <div class="card-header-actions">
          <CButton color="success" size="sm" @click="exportData()">Exportar a Excel</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable :tableFilter="tableFilter" :hover="hover" :striped="striped" :border="border" :small="small"
        :items="items" :fields="fields" :items-per-page="30" :dark="dark" pagination>
        <template #date="{ item }">
          <td class="text-center" style="font-size: 12px; padding: 0;">{{ item.date | date }}</td>
        </template>
        <template #entity_type="{ item }">
          <td class="text-center" style="font-size: 12px; padding: 0;">{{ item.entity_type_name }}</td>
        </template>
        <template #entity_name="{ item }">
          <td class="text-left">
            <span style="font-weight: bold; font-size: 14px;">{{ item.entity_code }} - {{ item.entity_name
            }}</span><br />
            <span style="font-style: italic; font-size: 12px;">{{ item.user_email }}</span><br />
            <span v-if="item.user_whatsapp" style="font-style: italic;">{{ item.user_whatsapp }}<br /></span>

          </td>
        </template>
        <template #award_name="{ item }">
          <td class="w300 text-left">
            <span style="font-weight: bold; font-size: 14px;">{{ item.name }}</span><br />
            <span style="font-style: italic; font-size: 12px;">{{ item.description }}</span>
          </td>
        </template>
        <template #price="{ item }">
          <td class="text-center" style="font-size: 12px; padding: 0;">
            <span
              v-html="item.type == 'event_points' ? 'Eventos' : (item.type == 'card_points' ? 'Certificados' : (item.type == 'gift_points' ? 'Premios' : item.type == 'wallet_points' ? 'Monedero' : '-'))"></span>
            <br>

            {{ (item.wallet_mode == 'normal' ? item.price : item.points) }}
          </td>
        </template>
        <template #status="{ item }">
          <td class="text-center" style="font-size: 12px; padding: 0;">
            <template v-if="item.is_paid">
              <span class="text-success">Entregado</span>
              <br>
              <small v-if="item.delivered_date">{{ item.delivered_date }}</small>
            </template>
            <template v-else>
              <span class="text-warning">Pendiente</span>
              <br>
              <small v-if="item.last_tracking_status">{{ item.last_tracking_status }}</small>
            </template>
          </td>
        </template>
        <template #actions="{ item }">
          <td class="text-center" style="font-size: 12px; padding: 0;">
            <span v-if="permissions['awards.write'] === true">
              <CButton v-if="item.is_paid" color="success" size="sm" @click="unpaidProcess(item.exchange_id)">
                <CIcon name="cil-check" />
              </CButton>
              <CButton v-if="!item.is_paid" color="danger" size="sm" @click="paidProcess(item.exchange_id)">
                <CIcon name="cil-ban" />
              </CButton>
            </span>
            <CButton style="margin-left: 3px;" color="info" size="sm" @click="openTrackingModal(item.exchange_id)">
              <CIcon name="cil-description" />
            </CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <AwardExchangeTrackingModal ref="awardExchangeTrackingModal" />
  </CCard>
</template>

<script>
import AwardExchangeTrackingModal from './AwardExchangeTrackingModal.vue'
import ws from '../../services/awards';
import store from '../../store'
import router from '../../router/index'

export default {
  name: 'AwardExchangesTable',
  components: { AwardExchangeTrackingModal },
  props: {
    items: Array,
    permissions: Object | Array,
    fields: {
      type: Array,
      default() {
        return [
          { key: 'date', label: 'Fecha Petición', _style: 'font-size: 12px; width: 75px !important;' },
          { key: 'entity_type', label: 'Rol', _style: 'font-size: 12px; width: 75px !important;' },
          { key: 'entity_name', label: 'Nombre', _style: 'width: 200px; font-size: 12px' },
          { key: 'award_name', label: 'Premio', _style: 'font-size: 12px' },
          { key: 'price', label: 'Tipo / Puntos', _style: 'font-size: 12px; width: 60px !important;' },
          { key: 'status', label: 'Estado', _style: 'font-size: 12px; width: 80px !important; padding: 0;' },
          { key: 'actions', label: '', _style: 'width: 60px !important; text-align: center;', sorter: false, filter: false }
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: [],
      challenge_id: 0,
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      }
    }
  },
  methods: {
    openTrackingModal(exchangeId) {
      this.$refs.awardExchangeTrackingModal.open(exchangeId);
    },
    async paidProcess(id) {
      let response = await ws.paid({ id: id });

      if (response.type == "success") {
        this.$emit("refresh", response.data);
      }

      this.showToast(response.type, response.message);
    },
    async unpaidProcess(id) {
      let response = await ws.unpaid({ id: id });

      if (response.type == "success") {
        this.$emit("refresh", response.data);
      }

      this.showToast(response.type, response.message);
    },
    async exportData() {
      this.loading();

      let response = await ws.getExcelAwardsExchanges();

      if (response.type == "success") {
        window.location = response.data;
      }

      this.loaded();
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message: message });
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    }
  }
}
</script>
